import { useEffect } from 'react'

import { useAuth } from 'pkg/authentication'

import trackEvent from 'utils/trackEvent'

import makeEventProperties from './lib/makeEventProperties'
import shouldReportView from './lib/shouldReportView'

const EVENT_NAME = 'Page Viewed'


// Reports a view of `trackingName`, and again whenever what it would report
// changes: a different website, a different policy type. A page that stays
// mounted while showing something else we do not report is still the same view,
// so it is reported once.
//
// The name is what analytics groups its reports by, so it is always English and
// is not the translated title the page shows the user.
//
// Callers own where `websiteID` and `properties` come from, because the URL and
// the route layout are theirs to know about. Both are read as they arrive, so
// pass values that are known on the first render: one that resolves later reports
// a second view of the same page.
//
export default function usePageViewedEvent({ properties, trackingName, websiteID }) {
  const { user } = useAuth()

  const isReportable = shouldReportView({
    trackingName,
    user,
  })

  const eventProperties = ( isReportable ) ? makeEventProperties({
    properties,
    trackingName,
    websiteID,
  }) : void 0

  const reportedView = JSON.stringify(eventProperties)

  // biome-ignore lint/correctness/useExhaustiveDependencies: eventProperties is watched through `reportedView`, which is built from it
  useEffect(() => {
    if ( !eventProperties ) {
      return
    }

    trackEvent(EVENT_NAME, eventProperties)
  }, [reportedView])
}
